import { isReportGenerating } from "./isReportGenerating";

import type { Report } from "../models/Reports";

export function areAllReportsGenerating(reports: Report[]) {
  return reports.every(isReportGenerating);
}
